export enum SERVICE_CATEGORY {
  All = 0,
  Sale = 1,
  Cost = 2,
}
